import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Footer = ({ displayType, activePath }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
          title
          siteUrl
        }
      }
    }
  `)
  return (
  	<footer>
      <div className="footer-info font-size-small ">
        <span itemScope itemType="http://schema.org/Place">
          <div itemProp="streetAddress">3/F GCI Building, 704 Rizal Ave. Ext.,</div>
          <div>Grace Park East, <span itemProp="addressLocality">Caloocan City</span>,</div>
          <div><span itemProp="addressRegion">Metro Manila</span>, <span itemProp="addressCountry">Philippines</span> 1403</div>
        </span>
        <br/>
        <br/>
        <div itemProp="email">info@iamnet.com.ph</div>
        <br/>
        <span className="font-style-bold">&copy; {new Date().getFullYear()} {data.site.siteMetadata.author}</span>
      </div>

  	</footer>
  )

}
Footer.propTypes = {
  displayType: PropTypes.number,
  activePath: PropTypes.string
}

Footer.defaultProps = {
  displayType: 3,
  activePath: ``
}

export default Footer
